const QGIV = QGIV || {};

$(document).ready(() => {
    let modalLaunched = false;
    let modalLaunchAttempts = 0;
    let launchModalInterval = undefined;
    const maxModalLaunchAttempts = 10;
    const intervalDuration = 100;
    const launchModal = () => {
        const $registerButton = $(".qgiv-load-modal");
        const eventUrl = $registerButton.attr("data-event-url");
        launchModalInterval = setInterval(() => {
            if (
                modalLaunched ||
                modalLaunchAttempts >= maxModalLaunchAttempts
            ) {
                clearInterval(launchModalInterval);
            } else {
                if (
                    QGIV &&
                    QGIV.Embed &&
                    QGIV.Embed.loadFullScreenModal &&
                    eventUrl
                ) {
                    QGIV.Embed.loadFullScreenModal(null, { eventUrl });
                    modalLaunched = true;
                } else {
                    modalLaunchAttempts++;
                }
            }
        }, intervalDuration);
    };
    const checkForLaunchModal = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const launchModalOnPageLoadFlag = $("#launch-modal-on-load").val();
        const shouldLaunchModal =
            urlParams.has("launchmodal") || launchModalOnPageLoadFlag === "1";
        if (shouldLaunchModal) {
            launchModal();
        }
    };

    checkForLaunchModal();
});
